import { apiClient } from "@/lib/api/http"

// Define types based on backend response
export interface CompanyVerification {
  id: string
  companyId: string
  documentUrl: string
  documentType: string
  documentIdentifier: string
  status: "PENDING" | "APPROVED" | "REJECTED" | string
  createdAt: string
  updatedAt: string
  company?: any // We can type it properly later, but it contains name, description, etc.
}

export interface GetAllVerificationsResponse {
  success: boolean
  statusCode: number
  message: string
  data: {
    verifications: CompanyVerification[]
  }
}

export interface GetCompanyDetailsResponse {
  success: boolean
  statusCode: number
  message: string
  data: any // The detailed company response
}

/**
 * 1. GET /company/verification/all
 */
export async function getAllCompanyVerifications(
  accessToken: string
): Promise<GetAllVerificationsResponse> {
  const { data } = await apiClient.get<GetAllVerificationsResponse>("/company/verification/all", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return data
}

/**
 * 2. GET /company/{id}
 */
export async function getAdminCompanyDetails(
  id: string,
  accessToken: string
): Promise<GetCompanyDetailsResponse> {
  const { data } = await apiClient.get<GetCompanyDetailsResponse>(`/company/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  return data
}

/**
 * 3. PATCH /company/verification/{id}/verify
 */
export async function updateCompanyVerification(
  id: string,
  status: string,
  accessToken: string
): Promise<any> {
  const { data } = await apiClient.patch<any>(`/company/verification/${id}/verify`, 
    { status },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )
  return data
}

/**
 * 4. PATCH /company/{id}/verify
 */
export async function updateCompanyStatus(
  id: string,
  status: string,
  accessToken: string
): Promise<any> {
  const { data } = await apiClient.patch<any>(`/company/${id}/verify`, 
    { status },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )
  return data
}
